import WellnessSurveyForm from "./WellnessSurveyForm";

export default function WellnessSurveyPage({showGlobalSnackbar})
{
   return <WellnessSurveyForm showGlobalSnackbar={showGlobalSnackbar} isEdit={false}/>
}
